<app-modal-confirm #confirmationModal></app-modal-confirm>

<ng-template #modal>
    <div class="modal-header">
        <h1 class="modal-title fs-5" id="dcModalLabel">
            {{ isEdit ? 'Edit' : 'Add' }} Distribution Center
        </h1>
        <button (click)="onDismiss()" type="button" class="btn-close" aria-label="Close"></button>
    </div>

    <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
        <div class="modal-body container-fluid">
            <div class="row g-0">
                @if (isEdit) {
                    <div class="form-floating col-md-8 mt-3">
                        <input type="text" class="form-control" id="dcPartnerNameControl" [value]="tradingPartnerName" disabled>
                        <label for="dcPartnerNameControl" class="form-label">Trading Partner</label>
                    </div>
                } @else {
                    <div class="form-floating col-md-8 mt-3" [class.is-invalid]="isFieldInvalid('tradingPartnerId')">
                        <select class="form-select" [class.is-invalid]="isFieldInvalid('tradingPartnerId')" id="dcPartnerIdControl" formControlName="tradingPartnerId">
                            <option disabled value="">Choose...</option>
                            @for (tradingPartner of tradingPartners; track tradingPartner.id) {
                                <option [value]="tradingPartner.id">{{ tradingPartner.name }}</option>
                            }
                        </select>
                        <label for="dcPartnerIdControl" class="form-label">Trading Partner</label>
                        <div class="invalid-feedback">Required</div>
                    </div>
                }

                <div class="form-check form-switch form-check-reverse col-md-4 mt-3 fs-5" style="padding-top: 1rem;">
                    <input class="form-check-input" type="checkbox" id="dcIsActiveControl" formControlName="isActive">
                    <label class="form-check-label" for="dcIsActiveControl">Active</label>
                </div>

                <div class="form-floating col-md-12 mt-3" [class.is-invalid]="isFieldInvalid('name')">
                    <input [class.is-invalid]="isFieldInvalid('name')" type="text" class="form-control" id="dcNameControl" formControlName="name">
                    <label for="dcNameControl" class="form-label">Name</label>
                    <div class="invalid-feedback">Required</div>
                </div>

                <div class="form-floating col-md-12 mt-3" [class.is-invalid]="isFieldInvalid('address1')">
                    <input [class.is-invalid]="isFieldInvalid('address1')" type="text" class="form-control" id="dcAddress1Control" formControlName="address1">
                    <label for="dcAddress1Control" class="form-label">Address 1</label>
                    <div class="invalid-feedback">Required</div>
                </div>

                <div class="form-floating col-md-12 mt-3">
                    <input type="text" class="form-control" id="dcAddress2Control" formControlName="address2">
                    <label for="dcAddress2Control" class="form-label">Address 2</label>
                </div>

                <div class="form-floating col-md-5 mt-3 vm-pe-1" [class.is-invalid]="isFieldInvalid('city')">
                    <input [class.is-invalid]="isFieldInvalid('city')" type="text" class="form-control" id="dcCityControl" formControlName="city">
                    <label for="dcCityControl" class="form-label">City</label>
                    <div class="invalid-feedback">Required</div>
                </div>

                <div class="form-floating col-md-4 mt-3 vm-pe-1" [class.is-invalid]="isFieldInvalid('state')">
                    <select class="form-select" [class.is-invalid]="isFieldInvalid('state')" id="dcStateControl" formControlName="state">
                        <option disabled value="">Choose...</option>
                        @for (state of globalService.stateList; track state.abbreviation) {
                            <option [value]="state.abbreviation">{{ state.name }}</option>
                        }
                    </select>
                    <label for="dcStateControl" class="form-label">State</label>
                    <div class="invalid-feedback">Required</div>
                </div>

                <div class="form-floating col-md-3 mt-3" [class.is-invalid]="isFieldInvalid('zipCode')">
                    <input [class.is-invalid]="isFieldInvalid('zipCode')" type="text" class="form-control" id="dcZipCodeControl" formControlName="zipCode">
                    <label for="dcZipCodeControl" class="form-label">Zip Code</label>
                    <div class="invalid-feedback">Required</div>
                </div>

                <div class="col-md-12 mt-4 display-6 vm-container-header">Identifiers</div>

                <div formArrayName="identifiers">
                    @for (identifier of identifierForm.controls; let i = $index; track identifier) {
                        <div class="row g-0" [formGroupName]="i">
                            <div class="form-floating col-md-6 mt-3 vm-pe-1" [class.is-invalid]="isControlInvalid(identifier.controls.qualifier)">
                                <select class="form-select" [class.is-invalid]="isControlInvalid(identifier.controls.qualifier)" [id]="'dcQualifierControl' + i" formControlName="qualifier">
                                    <option disabled [ngValue]="null">Choose...</option>
                                    @for (qualifier of IdentificationCodesDisplay | keyvalue; track qualifier.key) {
                                        <option [value]="qualifier.key">{{ qualifier.value }}</option>
                                    }
                                </select>
                                <label [for]="'dcQualifierControl' + i" class="form-label">Qualifier</label>
                                <div class="invalid-feedback">Required</div>
                            </div>

                            <div class="input-group has-validation col-md-6 mt-3">
                                <div class="form-floating" [class.is-invalid]="isControlInvalid(identifier.controls.value)">
                                    <input [class.is-invalid]="isControlInvalid(identifier.controls.value)" type="text" class="form-control" [id]="'dcValueControl' + i" formControlName="value">
                                    <label [for]="'dcValueControl' + i" class="form-label">Value</label>
                                </div>

                                @if (identifierForm.length > 1) {
                                    <button type="button" class="btn btn-outline-primary" (click)="confirmDeleteIdentifier(i)" aria-label="Delete identifier">
                                        <i class="bi bi-trash"></i>
                                    </button>
                                }

                                <div class="invalid-feedback">Required</div>
                            </div>
                        </div>
                    }

                    <div class="row g-0">
                        <div class="col-md-12 mt-3 text-end">
                            <button type="button" class="btn btn-outline-primary btn-sm" (click)="addIdentifier(null, distributionCenterId)" aria-label="Add identifier">
                                <i class="bi bi-plus-circle"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <button type="submit" class="btn btn-primary" [disabled]="savingData">
                @if (savingData) {
                    <span class="spinner-border spinner-border-sm me-1"></span>
                }
                Save
            </button>
            <button type="button" class="btn btn-secondary" (click)="onDismiss()">Close</button>
        </div>
    </form>
</ng-template>
